export default "__VITE_ASSET__sBmmFTnW__"